/**
 * Split a polygon ring into sub-rings at antimeridian crossings.
 *
 * A "ring" is a sequence of [lon, lat] coordinates. When two consecutive
 * points have a longitude delta > 180°, the ring crosses the ±180° line.
 * Drawing lines between those two points without splitting produces a
 * streak across the Pacific (e.g. Russia's Chukotka to Alaska appearing
 * as a horizontal line across the South Pacific).
 *
 * Runtime splitting is pragmatic — the alternative is build-time splitting
 * with proper geodesic interpolation at ±180°, which is more accurate but
 * more setup. Runtime produces a tiny visible gap at the antimeridian
 * (one segment missing), acceptable for border rendering.
 */
export function splitAtAntimeridian(ring: [number, number][]): [number, number][][] {
  if (ring.length < 2) return [ring];

  const segments: [number, number][][] = [];
  let current: [number, number][] = [ring[0]];

  for (let i = 1; i < ring.length; i++) {
    const [prevLon] = ring[i - 1];
    const [lon] = ring[i];
    if (Math.abs(lon - prevLon) > 180) {
      // Crossing detected. End current sub-ring, start a new one.
      if (current.length >= 2) segments.push(current);
      current = [ring[i]];
    } else {
      current.push(ring[i]);
    }
  }

  if (current.length >= 2) segments.push(current);
  return segments;
}
